import {Lobe, Roi} from 'api/analysisApi'
import EEGSummaryBrain3D from 'components/molcules/ProfitSummaryReport/EEG/EEGSummaryBrain3d'
import EEGSummaryLobe from 'components/molcules/ProfitSummaryReport/EEG/EEGSummaryLobe'
import EEGSummaryOpinion from 'components/molcules/ProfitSummaryReport/EEG/EEGSummaryOpnion'
import useStyles from 'components/molcules/ProfitSummaryReport/useStyles'
import RoiComponent from 'components/molcules/Report/RoiComponent'
import React, {ReactNode, useEffect} from 'react'
import {useTranslation} from 'react-i18next'

interface EEGSummaryProps {
  contourImage?: string
  threeDimensionImage: string
  total: number
  CustomerCard?: ReactNode
  reportType: ReportType
  isSummary?: boolean
  lobe: Lobe
  roi: Roi
}

export default function EEGSummary(props: EEGSummaryProps) {
  const {
    contourImage,
    threeDimensionImage,
    total,
    lobe,
    roi,
    CustomerCard,
    reportType,
    isSummary,
  } = props
  const classes = useStyles()
  const {t} = useTranslation()

  const handleTop = () => {
    const scroll = document.getElementById('root')

    scroll?.scrollTo(0, 0)
  }

  useEffect(() => {
    handleTop()
  }, [])

  return (
    <div className={classes.root}>
      {CustomerCard && CustomerCard}
      <EEGSummaryBrain3D
        index={1}
        threeDimensionImage={threeDimensionImage}
        isSummary={isSummary}
      />
      {lobe !== null && lobe !== undefined && (
        <EEGSummaryLobe index={2} lobe={lobe} isSummary={isSummary} />
      )}
      <EEGSummaryOpinion
        index={3}
        score={total}
        contourImage={contourImage}
        isSummary={isSummary}
      />
      {lobe != null &&
        lobe !== undefined &&
        roi != null &&
        roi !== undefined &&
        reportType === 'P2' && <RoiComponent roi={roi} lobe={lobe} />}
      <p className='Warning'>{t('IEEGSummaryReportWarning')}</p>
    </div>
  )
}
